import React from 'react';
import { styled } from '@mui/material';

const NoCostContainer = styled('div')<{ spacing?: number }>(({ theme, spacing }) => ({
  marginTop: theme.spacing(spacing || 0),
}));

export const LayoutSpacer = ({ spacing = 20 }: { spacing?: number }) => {
  return <NoCostContainer spacing={spacing} />;
};
